<ng-container *ngIf="_notificationsToShow$ | async as notifications">
	<div [insideClick]="true" [autoClose]="true" dropdown placement="bottom right">
		<a data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false" dropdownToggle #toggleRef>
			<i class="far fa-bell" data-test-id="bell-icon"></i>
			<ng-container *ngIf="notifications">
				<span class="notifications-count" [class.badge-danger]="notifications.length">
					{{ notifications.length }}
				</span>
			</ng-container>
		</a>
		<div class="notifications-list dropdown-menu dropdown-menu-right mt-2" *dropdownMenu>
			<ng-container *ngIf="(_oldNotificationsToShow$ | async).length">
				<div class="dropdown-item alert alert-info" *ngFor="let alert of _oldNotificationsToShow$ | async">
					<alert
						[dismissible]="alert.hasOwnProperty('dismissible') ? alert.dismissible : true"
						(onClosed)="onClosed(alert)"
						[type]="alert.type"
					>
						<div class="d-flex justify-content-between align-items-center">
							<div [innerHTML]="alert.text"></div>
							<button
								type="button"
								class="btn btn-outline-dark"
								[disabled]="isLoading"
								*ngIf="alert.emailResend"
								(click)="resendConfirmation()"
							>
								Resend
							</button>
						</div>
					</alert>
				</div>
			</ng-container>
			<ng-template #innApp>
				<ng-container *ngIf="notifications.length; else noAlerts">
					<div class="d-flex justify-content-between align-items-center notifications-padding">
						<div>
							<mat-checkbox
								*ngIf="!allNotificationsOfCurrentOrg"
								[color]="'primary'"
								[(ngModel)]="showNotificationsForCurrentOrg"
							>
								Show alerts related to the selected organization only
							</mat-checkbox>
						</div>

						<button
							class="btn btn-sm white-btn text-uppercase ml-3 mt-1"
							data-test-id="dismiss-all"
							(click)="dismiss($event)"
						>
							Dismiss all <i class="fa fa-window-close" aria-hidden="true"></i>
						</button>
					</div>
					<div class="row notifications-list__item-header">
						<div class="col-6">Name</div>
						<div class="col-3">Org</div>
						<div class="col-3">Time</div>
					</div>
					<ng-container
						*ngFor="
							let notification of notifications
								| filterCurrentOrganizations : current_org_id : showNotificationsForCurrentOrg
						"
					>
						<div
							[@fadeInOut]="determineNotificationStatus(notification)"
							class="row notifications-list__item"
							(click)="toggleHelpMenu(notification)"
						>
							<div class="col-6">
								<i class="fas fa-chevron-down" [@rotateInOut]="getExpandStatus(notification)"></i>
								{{ notification.data.product }}:
								<span #tooltip="matTooltip" [matTooltip]="notification.title" *ngIf="notification.title">
									{{ notification.title | cropStringPipe : 0 : 45 : '' : '...' }}
								</span>
							</div>
							<div class="col-3">
								<div *ngIf="notification.org_name">
									{{ notification.org_name | cropStringPipe : 0 : 30 : '' : '...' }}
									<i
										*ngIf="!isCurrentOrg(notification.org_id)"
										class="fas fa-exclamation-triangle info_icon ml-1 mr-1"
										matTooltip="This notification is associated with an organization that you are not signed in with."
									>
									</i>
								</div>
							</div>
							<div class="col-3 d-flex justify-content-between align-items-center">
								{{ notification.date | date : 'MMM d, y, HH:mm:ss' }}
								<i
									class="fa fa-window-close"
									[ngClass]="getNotificationUpdateStatus(notification)"
									(click)="dismiss($event, notification)"
									aria-hidden="true"
								></i>
							</div>
						</div>
						<div class="row notifications-list__item-content" [@slideInOut]="getExpandStatus(notification)">
							<div class="col-12">
								<div class="mt-1 mb-1">
									<span class="fz-600" *ngIf="notification.org_name"> Organization: </span>
									{{ notification.org_name }}
								</div>
								<div class="mt-1 mb-1">
									<span class="fz-600" *ngIf="notification.org_id">Organization id:</span>{{ notification.org_id }}
								</div>
								<div class="mt-1 mb-1">
									<span class="fz-600" *ngIf="notification.data.instance_id">Instance id:</span>
									{{ notification.data.instance_id }}
								</div>
								<div class="mt-1 mb-1">
									<span class="fz-600" *ngIf="notification.data.description">Description:</span>
									{{ notification.data.description }}
								</div>
								<div class="mt-1 mb-1">
									<span class="fz-600" *ngIf="notification.data.mount_path">Mount Path:</span>
									{{ notification.data.mount_path }}
								</div>
							</div>
						</div>
						<div class="hr-line"></div>
					</ng-container>
				</ng-container>
				<ng-template #noAlerts>
					<div class="alert alert-info no-notifications" data-test-id="no-notifications-block">
						<svg class="no-notifications-image">
							<use xlink:href="#svg-no-notifications">
								<svg id="svg-no-notifications" viewBox="0 0 161 98">
									<g fill="none" fill-rule="evenodd">
										<g transform="translate(0 13)" fill="#ECEDEF" opacity=".2">
											<path
												d="M89.43 23.51a6.33 6.33 0 100-12.659h34.736a6.33 6.33 0 000 12.66H89.43zm3.604 23.511a6.33 6.33 0 100-12.66h34.736a6.33 6.33 0 100 12.66H93.034z"
											></path>
											<rect x="30.84" width="127.96" height="12.66" rx="6.33"></rect>
											<rect x="40.02" y="23.51" width="120.75" height="12.66" rx="6.33"></rect>
											<rect x=".83" y="47.02" width="135.16" height="12.66" rx="6.33"></rect>
											<path d="M68.968 72.34a6.33 6.33 0 100-12.66h34.737a6.33 6.33 0 100 12.66H68.968z"></path>
											<rect x="52" y="72.34" width="82.9" height="12.66" rx="6.33"></rect>
										</g>
										<path
											d="M108.387 56.65c-3.579-11.784-2.868-22.565-2.406-26.608.087-.528.161-1.058.215-1.596.01-.057.015-.096.015-.096h-.008c.078-.806.12-1.625.12-2.453C106.323 11.871 94.953.5 80.925.5 66.9.5 55.528 11.871 55.528 25.897c0 .828.043 1.647.12 2.453h-.002l.004.025c.057.596.14 1.186.238 1.771.462 4.124 1.13 14.825-2.418 26.504-2.227 7.332-5.097 11.703-7.445 14.254-1.175 1.275-.25 3.336 1.485 3.336h66.837c1.735 0 2.66-2.06 1.485-3.336-2.348-2.55-5.218-6.922-7.445-14.254"
											fill="#FFF"
										></path>
										<path
											d="M108.387 56.65c-3.579-11.784-2.868-22.565-2.406-26.608.087-.528.161-1.058.215-1.596.01-.057.015-.096.015-.096h-.008c.078-.806.12-1.625.12-2.453C106.323 11.871 94.953.5 80.925.5 66.9.5 55.528 11.871 55.528 25.897c0 .828.043 1.647.12 2.453h-.002l.004.025c.057.596.14 1.186.238 1.771.462 4.124 1.13 14.825-2.418 26.504-2.227 7.332-5.097 11.703-7.445 14.254-1.175 1.275-.25 3.336 1.485 3.336h66.837c1.735 0 2.66-2.06 1.485-3.336-2.348-2.55-5.218-6.922-7.445-14.254z"
											stroke="#C6CACF"
										></path>
										<path
											d="M66.94 78.828c-1.01 0-1.687 1.086-1.198 1.97 2.957 5.346 8.645 8.97 15.187 8.97s12.228-3.622 15.186-8.966c.49-.886-.188-1.974-1.201-1.974H66.94z"
											fill="#ECEDEF"
										></path>
										<path
											d="M66.94 78.828c-1.01 0-1.687 1.086-1.198 1.97 2.957 5.346 8.645 8.97 15.187 8.97s12.228-3.622 15.186-8.966c.49-.886-.188-1.974-1.201-1.974H66.94z"
											stroke="#C6CACF"
										></path>
									</g>
								</svg>
							</use>
						</svg>
						<span class="text-muted">All caught up!</span>
					</div>
				</ng-template>
			</ng-template>
			<app-spinner *ngIf="isUpdating$ | async; else innApp"></app-spinner>
		</div>
	</div>
</ng-container>
